import dayjs from "dayjs";
import { supabase } from "../../config/supabaseClient";

export async function getPageEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    let rpcName = "get_overview_views_date_embed_analyticssss"; // default
    const routeName = `/embed/${username}`;
  
    if (daysNumber === 1) {
      rpcName = "get_overview_views_date_embed_analyticsssyy";
      startDate = dayjs().utc().subtract(0, "day").format("YYYY-MM-DD"); // Today
    } else if (daysNumber !== 0 && daysNumber !== 7 && daysNumber !== 30 && daysNumber !== undefined) {
      rpcName = "get_page_views_date_embed_analyticsssy";
    }else if(daysNumber === undefined || daysNumber === 0 ){
      rpcName = "get_overview_views_date_embed_analyticssssall"
    }
  
    const rpcParams: any = {
      route_name: routeName,
      start_date: startDate,
      end_date: endDate,
      userid: user_id
    };
  
    // Only add is_yesterday parameter for specific RPC calls
    if (rpcName === "get_overview_views_date_embed_analyticsssyy" ) {
      rpcParams.is_yesterday = isYesterday;
    }
  
    const { data } = await supabase.rpc(rpcName, rpcParams);
  
    if (!data || !data.length) return 0;
  
    // Post-process data
    if (daysNumber === 7) return data.slice(1).reverse();
    if (daysNumber === 1) return data.slice(3).reverse();
    return data.reverse();
  }




  export async function getUserViewsEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    if (
      daysNumber === 0 ||
      daysNumber === 30 ||
      daysNumber === 7 ||
      daysNumber === undefined
    ) {
      const { data } = await supabase.rpc("get_user_views_date_embed_analyticsss", {
        route_name: `/embed/${username}`,
        start_date: startDate,
        end_date: endDate,
        userid: user_id,
      });
      if (data && data.length) {
        return data.reverse();
      } else {
        return 0;
      }
    } else if (daysNumber === 1) {
      let { data } = await supabase.rpc("get_user_views_date_embed_analyticsssy", {
        route_name: `/embed/${username}`,
        start_date: dayjs().utc().subtract(0, "day").format("YYYY-MM-DD"),
  
        end_date: endDate,
        userid: user_id,
        is_yesterday: isYesterday,
      });
      if (data && data.length) {
        if (daysNumber === 7) {
          data = data.slice(1);
  
          return data.reverse();
        } else if (daysNumber === 1) {
          data = data.slice(3);
  
          return data.reverse();
        } else {
          return data;
        }
      } else {
        return 0;
      }
    } else {
      let { data } = await supabase.rpc("get_user_views_date_embed_analyticsssy", {
        route_name: `/embed/${username}`,
        start_date: startDate,
        end_date: endDate,
        userid: user_id,
        is_yesterday: isYesterday,
      });
      if (data && data.length) {
        if (daysNumber === 7) {
          data = data.slice(1);
  
          return data.reverse();
        } else if (daysNumber === 1) {
          data = data.slice(3);
  
          return data.reverse();
        } else {
          return data;
        }
      } else {
        return 0;
      }
    }
  }


  export async function getPostEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    const { data } = await supabase.rpc("get_post_views_date_embed_analyticssss", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
    if (data && data.length) {
      return data.reverse();
    } else {
      return 0;
    }
  }



  export async function getSocialLinksEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    let socialLinksData: any = [];
    const { data } = await supabase.rpc("get_social_links_embed_analyticss", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
    if (data) {
      // Create a map to store aggregated data by platform
      const platformMap = new Map();
      let indexCharCode = 65;
  
      for (let d of data) {
        const details = JSON.parse(d.post);
        const platform = details.social;
  
        if (platformMap.has(platform)) {
          // If platform exists, add to its clicks
          const existingEntry = platformMap.get(platform);
          existingEntry.clicks += d.count;
        } else {
          // If platform doesn't exist, create new entry
          platformMap.set(platform, {
            clicks: d.count,
            social: platform,
            link: details.link, // Store most recent link
            index: String.fromCharCode(indexCharCode++),
          });
        }
      }
  
      // Convert map to array
      socialLinksData = Array.from(platformMap.values());
    }
  
    return socialLinksData;
  }


  export async function getMyLinksEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    let myLinksData: any = [];
    const { data } = await supabase.rpc("get_my_links_embed_analyticss", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
  
    if (data) {
      let indexCharCode = 65;
  
      for (let d of data) {
        const details = JSON.parse(d.post);
  
        let existingEntry = myLinksData.find(
          (entry: any) => entry.link === details.link
        );
  
        if (existingEntry) {
          existingEntry.count += d.count;
        } else {
          myLinksData.push({
            clicks: d.count,
            link: details.link,
            url: details.url,
            index: String.fromCharCode(indexCharCode),
          });
          indexCharCode++;
        }
      }
    }
  
    return myLinksData;
  }



  export async function getPostClicksEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    let postClicksObj: any = [];
    const { data } = await supabase.rpc("get_post_clicks_embed_analyticss", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
    if (data) {
      const transformedData = data.reduce((acc: any, item: any) => {
        const post = JSON.parse(item.post);
        if (!acc[post.title]) {
          acc[post.title] = [];
        }
  
        acc[post.title].push({
          post_id: post.post_id,
          media_url: post.media_url,
          count: item.count,
          name: post.name,
        });
  
        return acc;
      }, {});
      return transformedData;
    }
  }




  export async function getPostClicksViewsEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    if (
      daysNumber === 0 ||
      daysNumber === 30 ||
      daysNumber === 7 ||
      daysNumber === undefined
    ) {
      let { data, error } = await supabase.rpc(
        "get_post_clicks_views_date_embed_analyticsss",
        {
          route_name: `/embed/${username}`,
          start_date: startDate,
          end_date: endDate,
          userid: user_id,
        }
      );
      if (data && data.length) {
        data.reverse();
  
        const acc: any = {};
  
        data.forEach((item: any) => {
          const post = JSON.parse(item.post);
          const title = post.title;
  
          if (!acc[title]) {
            acc[title] = [];
          }
  
          const existingDateEntry = acc[title].find(
            (entry: any) => entry.formatted_date === item.formatted_date
          );
  
          if (existingDateEntry) {
            existingDateEntry.clicks += item.count;
          } else {
            acc[title].push({
              formatted_date: item.formatted_date,
              clicks: item.count,
            });
          }
        });
        return acc;
      } else {
        return 0;
      }
    } else if (daysNumber === 1) {
      let { data } = await supabase.rpc(
        "get_post_clicks_views_date_embed_analyticsssy",
        {
          route_name: `/embed/${username}`,
          start_date: dayjs().utc().subtract(0, "day").format("YYYY-MM-DD"),
  
          end_date: endDate,
          userid: user_id,
          is_yesterday: isYesterday,
        }
      );
      if (data && data.length) {
        if (daysNumber === 7) {
          data = data.slice(1);
          data.reverse();
  
          const acc: any = {};
  
          data.forEach((item: any) => {
            const post = JSON.parse(item.post);
            const title = post.title;
  
            if (!acc[title]) {
              acc[title] = [];
            }
  
            const existingDateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (existingDateEntry) {
              existingDateEntry.count += item.count;
            } else {
              acc[title].push({
                formatted_date: item.formatted_date,
                clicks: item.count,
              });
            }
          });
  
          return acc;
        } else if (daysNumber === 1) {
          data = data.slice(3);
  
          data.reverse();
  
          const acc: any = {};
  
          data.forEach((item: any) => {
            const post = JSON.parse(item.post);
            const title = post.title;
  
            if (!acc[title]) {
              acc[title] = [];
            }
  
            const existingDateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (existingDateEntry) {
              existingDateEntry.count += item.count;
            } else {
              acc[title].push({
                formatted_date: item.formatted_date,
                clicks: item.count,
              });
            }
          });
  
          return acc;
        } else {
          data.reverse();
  
          const acc: any = {};
  
          data.forEach((item: any) => {
            const post = JSON.parse(item.post);
            const title = post.title;
  
            if (!acc[title]) {
              acc[title] = [];
            }
  
            const existingDateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (existingDateEntry) {
              existingDateEntry.count += item.count;
            } else {
              acc[title].push({
                formatted_date: item.formatted_date,
                clicks: item.count,
              });
            }
          });
  
          return acc;
        }
      } else {
        return 0;
      }
    } else {
      let { data } = await supabase.rpc("get_post_clicks_date_embed_analyticsssy", {
        route_name: `/embed/${username}`,
        start_date: startDate,
        end_date: endDate,
        userid: user_id,
        is_yesterday: isYesterday,
      });
      if (data && data.length) {
        if (daysNumber === 7) {
          data = data.slice(1);
          data.reverse();
  
          const acc: any = {};
  
          data.forEach((item: any) => {
            const post = JSON.parse(item.post);
            const title = post.title;
  
            if (!acc[title]) {
              acc[title] = [];
            }
  
            const existingDateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (existingDateEntry) {
              existingDateEntry.count += item.count;
            } else {
              acc[title].push({
                formatted_date: item.formatted_date,
                clicks: item.count,
              });
            }
          });
  
          return acc;
        } else if (daysNumber === 1) {
          data = data.slice(3);
          data.reverse();
  
          const acc: any = {};
  
          data.forEach((item: any) => {
            const post = JSON.parse(item.post);
            const title = post.title;
  
            if (!acc[title]) {
              acc[title] = [];
            }
  
            const existingDateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (existingDateEntry) {
              existingDateEntry.count += item.count;
            } else {
              acc[title].push({
                formatted_date: item.formatted_date,
                clicks: item.count,
              });
            }
          });
  
          return acc;
        } else {
          data.reverse();
  
          const acc: any = {};
  
          data.forEach((item: any) => {
            const post = JSON.parse(item.post);
            const title = post.title;
  
            if (!acc[title]) {
              acc[title] = [];
            }
  
            const existingDateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (existingDateEntry) {
              existingDateEntry.count += item.count;
            } else {
              acc[title].push({
                formatted_date: item.formatted_date,
                clicks: item.count,
              });
            }
          });
  
          return acc;
        }
      } else {
        return 0;
      }
    }
  }





  export async function getCarouselClicksViewsEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
    //csd
  ) {
    if (
      daysNumber === 0 ||
      daysNumber === 30 ||
      daysNumber === 7 ||
      daysNumber === undefined
    ) {
      let { data, error } = await supabase.rpc(
        "get_carousel_clicks_views_date_embed_analyticsss",
        {
          route_name: `/embed/${username}`,
          start_date: startDate,
          end_date: endDate,
          userid: user_id,
        }
      );
     
  
      if (data && data.length) {
        data.reverse(); // Ensure chronological order
        const acc: any = {};
        const allDates = new Set<string>();
        const titles = new Set<string>();
  
        // First pass: extract unique titles and dates
        data.forEach((item: any) => {
          allDates.add(item.formatted_date);
  
          if (item.post) {
            try {
              const post = JSON.parse(item.post);
              const title = post?.title || "Untitled";
              titles.add(title);
            } catch {
              // skip invalid JSON
            }
          }
        });
  
        // Initialize accumulator with all titles and all dates (count = 0)
        titles.forEach((title) => {
          acc[title] = Array.from(allDates).map((date) => ({
            formatted_date: date,
            clicks: 0,
          }));
        });
  
        // Second pass: fill actual values into acc
        data.forEach((item: any) => {
          if (!item.post) return; // Only update values where post exists
  
          let post;
          try {
            post = JSON.parse(item.post);
          } catch {
            return;
          }
  
          const title = post?.title || "Untitled";
  
          const dateEntry = acc[title].find(
            (entry: any) => entry.formatted_date === item.formatted_date
          );
  
          if (dateEntry) {
            dateEntry.clicks += item.count;
          }
        });
        return acc;
      } else {
        return 0;
      }
    }
    
    else {
      let { data } = await supabase.rpc("get_carousel_clicks_date_embed_analyticsssy", {
        route_name: `/embed/${username}`,
        start_date: startDate,
        end_date: endDate,
        userid: user_id,
        is_yesterday: isYesterday,
      });
      if (data && data.length) {
        if (daysNumber === 7) {
          data = data.slice(1);
          data.reverse(); // Ensure chronological order
          const acc: any = {};
          const allDates = new Set<string>();
          const titles = new Set<string>();
  
          // First pass: extract unique titles and dates
          data.forEach((item: any) => {
            allDates.add(item.formatted_date);
  
            if (item.post) {
              try {
                const post = JSON.parse(item.post);
                const title = post?.title || "Untitled";
                titles.add(title);
              } catch {
                // skip invalid JSON
              }
            }
          });
  
          // Initialize accumulator with all titles and all dates (count = 0)
          titles.forEach((title) => {
            acc[title] = Array.from(allDates).map((date) => ({
              formatted_date: date,
              clicks: 0,
            }));
          });
  
          // Second pass: fill actual values into acc
          data.forEach((item: any) => {
            if (!item.post) return; // Only update values where post exists
  
            let post;
            try {
              post = JSON.parse(item.post);
            } catch {
              return;
            }
  
            const title = post?.title || "Untitled";
  
            const dateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (dateEntry) {
              dateEntry.clicks += item.count;
            }
          });
          return acc;
        } else if (daysNumber === 1) {
          data = data.slice(3);
          data.reverse(); // Ensure chronological order
          const acc: any = {};
          const allDates = new Set<string>();
          const titles = new Set<string>();
  
          // First pass: extract unique titles and dates
          data.forEach((item: any) => {
            allDates.add(item.formatted_date);
  
            if (item.post) {
              try {
                const post = JSON.parse(item.post);
                const title = post?.title || "Untitled";
                titles.add(title);
              } catch {
                // skip invalid JSON
              }
            }
          });
  
          // Initialize accumulator with all titles and all dates (count = 0)
          titles.forEach((title) => {
            acc[title] = Array.from(allDates).map((date) => ({
              formatted_date: date,
              clicks: 0,
            }));
          });
  
          // Second pass: fill actual values into acc
          data.forEach((item: any) => {
            if (!item.post) return; // Only update values where post exists
  
            let post;
            try {
              post = JSON.parse(item.post);
            } catch {
              return;
            }
  
            const title = post?.title || "Untitled";
  
            const dateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (dateEntry) {
              dateEntry.clicks += item.count;
            }
          });
          return acc;
        } else {
          data.reverse();
  
          data.reverse(); // Ensure chronological order
          const acc: any = {};
          const allDates = new Set<string>();
          const titles = new Set<string>();
  
          // First pass: extract unique titles and dates
          data.forEach((item: any) => {
            allDates.add(item.formatted_date);
  
            if (item.post) {
              try {
                const post = JSON.parse(item.post);
                const title = post?.title || "Untitled";
                titles.add(title);
              } catch {
                // skip invalid JSON
              }
            }
          });
  
          // Initialize accumulator with all titles and all dates (count = 0)
          titles.forEach((title) => {
            acc[title] = Array.from(allDates).map((date) => ({
              formatted_date: date,
              clicks: 0,
            }));
          });
  
          // Second pass: fill actual values into acc
          data.forEach((item: any) => {
            if (!item.post) return; // Only update values where post exists
  
            let post;
            try {
              post = JSON.parse(item.post);
            } catch {
              return;
            }
  
            const title = post?.title || "Untitled";
  
            const dateEntry = acc[title].find(
              (entry: any) => entry.formatted_date === item.formatted_date
            );
  
            if (dateEntry) {
              dateEntry.clicks += item.count;
            }
          });
          return acc;
        }
      } else {
        return 0;
      }
    }
  }







  export async function getUniqueEmbedUsers(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any
  ) {
    const { data, error } = await supabase.rpc("fetch_unique_users_date_rangee_embed", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
    if (data && data.length) {
      return data[0].count;
    } else {
      return 0;
    }
  }
  export async function getPageViewsEmbed(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any
  ) {
    const { data } = await supabase.rpc("get_page_views_date_rangee_embed", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
  
    if (data && data.length) {
      return data[0].count;
    } else {
      return 0;
    }
  }




  export async function getCarouselViewsEmbed(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any
  ) {
    const { data } = await supabase.rpc("get_carousel_views_date_range_embed", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
    const acc: any = {};
  
    data.forEach((item: any) => {
      const post = JSON.parse(item.details);
      const title = post.title;
      const unique_id = post.unique_id;
  
      // Initialize an empty array if this title doesn't exist in the accumulator
      if (!acc[title]) {
        acc[title] = [];
      }
  
      // Find the entry with the same unique_id for this title
      const existingEntry = acc[title].find(
        (entry: any) => entry.unique_id === unique_id
      );
  
      if (existingEntry) {
        // If entry exists, increment the clicks to count duplicates
        existingEntry.clicks += 1;
      } else {
        // Otherwise, add a new entry with clicks initialized to 1
        acc[title].push({
          unique_id: unique_id,
          clicks: 1, // Start with 1 for the first occurrence
        });
      }
    });
    if (data && data.length) {
      return acc;
    } else {
      return 0;
    }
  }





  export async function getCarouselClicksEmbedAnalytics(
    username: any,
    startDate: any,
    endDate: any,
    user_id: any,
    isYesterday: any,
    daysNumber: any
  ) {
    const { data } = await supabase.rpc("get_carousel_clicks_embed_analyticsss", {
      route_name: `/embed/${username}`,
      start_date: startDate,
      end_date: endDate,
      userid: user_id,
    });
    if (data) {
      const transformedData = data.reduce((acc: any, item: any) => {
        const post = JSON.parse(item.post);
        const { post_id, media_url, name, id, created_at } = post;
        if (!acc[post.title]) {
          acc[post.title] = [];
        }
  
        const existingEntry = acc[post.title].find(
          (entry: any) => entry.post_id === post_id
        );
  
        if (existingEntry) {
          if (id) {
            existingEntry.idCount = (existingEntry.idCount || 0) + item.count;
          }
          if (!id) {
            existingEntry.count = (existingEntry.count || 0) + item.count;
          }
          if (id && !existingEntry.id) {
            existingEntry.id = id;
          }
          
          // Update name if the current item's created_at is more recent
          if (new Date(item.created_at) > new Date(existingEntry.created_at)) {
            existingEntry.name = name;
            existingEntry.created_at = item.created_at;
          }
        } else {
          // Create a new entry for the post_id with count and/or idCount as applicable
        
          
          const newEntry: any = {
            post_id,
            media_url,
            name,
            created_at: item.created_at,
            platform: post.platform,
            count: item.count,
            ...(post.id ? { id: post.id, idCount: item.count } : {})
          };
          
  
          acc[post.title].push(newEntry);
        }
  
        return acc;
      }, {});
      Object.keys(transformedData).forEach((title) => {
        transformedData[title] = transformedData[title].sort(
          (a: any, b: any) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
      });
      return transformedData;
    }
  }